import FavoriteIcon from '@mui/icons-material/Favorite';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import LocalFloristOutlinedIcon from '@mui/icons-material/LocalFloristOutlined';
import WbIncandescentOutlinedIcon from '@mui/icons-material/WbIncandescentOutlined';
import StreamOutlinedIcon from '@mui/icons-material/StreamOutlined';
import SportsHandballOutlinedIcon from '@mui/icons-material/SportsHandballOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import SpeakerOutlinedIcon from '@mui/icons-material/SpeakerOutlined';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import Face2Icon from '@mui/icons-material/Face2';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';
import Man3OutlinedIcon from '@mui/icons-material/Man3Outlined';
import CommuteOutlinedIcon from '@mui/icons-material/CommuteOutlined';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import BusinessIcon from '@mui/icons-material/Business';
import CakeIcon from '@mui/icons-material/Cake';

import image0 from '../assets/images/image0.webp';
import image2 from '../assets/images/image2.jpeg';
import image3 from '../assets/images/image3.jpeg';
import image4 from '../assets/images/image4.jpeg';
import image8 from '../assets/images/image8.jpeg';
import image9 from '../assets/images/image9.jpeg';
import image10 from '../assets/images/image10.jpeg';
import image11 from '../assets/images/image11.png';
import image12 from '../assets/images/image12.webp';
import image13 from '../assets/images/image13.webp';
import image14 from '../assets/images/image14.webp';
import image15 from '../assets/images/image15.webp';
import image16 from '../assets/images/image16.webp';
import image17 from '../assets/images/image17.webp';
import image21 from '../assets/images/image21.png';
import image22 from '../assets/images/image22.png';
import image23 from '../assets/images/image23.png';
import image24 from '../assets/images/image24.png';
import image25 from '../assets/images/image25.png';
import image26 from '../assets/images/image26.png';
import image27 from '../assets/images/image27.png';
import image28 from '../assets/images/image28.png';
import image31 from '../assets/images/image31.jpeg';
import image32 from '../assets/images/image32.jpeg';

const ICON_MAP = {
    'CelebrationOutlinedIcon': <CelebrationOutlinedIcon fontSize='large' />,
    'LocalFloristOutlinedIcon': <LocalFloristOutlinedIcon fontSize='large' />,
    'WbIncandescentOutlinedIcon': <WbIncandescentOutlinedIcon fontSize='large' />,
    'StreamOutlinedIcon': <StreamOutlinedIcon fontSize='large' />,
    'SportsHandballOutlinedIcon': <SportsHandballOutlinedIcon fontSize='large' />,
    'PhotoCameraOutlinedIcon': <PhotoCameraOutlinedIcon fontSize='large' />,
    'SpeakerOutlinedIcon': <SpeakerOutlinedIcon fontSize='large' />,
    'MusicNoteOutlinedIcon': <MusicNoteOutlinedIcon fontSize='large' />,
    'Face2Icon': <Face2Icon fontSize='large' />,
    'ColorLensIcon': <ColorLensIcon fontSize='large' />,
    'KeyboardVoiceOutlinedIcon': <KeyboardVoiceOutlinedIcon fontSize='large' />,
    'Man3OutlinedIcon': <Man3OutlinedIcon fontSize='large' />,
    'CommuteOutlinedIcon': <CommuteOutlinedIcon fontSize='large' />,
    'CheckroomIcon': <CheckroomIcon fontSize='large' />,
    'Diversity1Icon': <Diversity1Icon fontSize='large' />,
    'BusinessIcon': <BusinessIcon fontSize='large' />,
    'CakeIcon': <CakeIcon fontSize='large' />,
};

export const getIcon = (iconName) => {
    return ICON_MAP[iconName] || <FavoriteIcon fontSize='large' />;
};

const IMAGE_MAP = {
    'decor': image17,
    'professional': image12,
    'price': image13,
    'consultation': image14,
    'support': image15,
    'delightful': image16,
    'image0': image0,
    'image2': image2,
    'image3': image3,
    'image4': image4,
    'image9': image9,
    'image10': image10,
    'image11': image11,
    'image21': image21,
    'image22': image22,
    'image23': image23,
    'image24': image24,
    'image25': image25,
    'image26': image26,
    'image27': image27,
    'image28': image28,
    'image31': image31,
    'image32': image32,
};

export const getImage = (imageName) => {
    return IMAGE_MAP[imageName] || image8;
};
